import React, { Component } from 'react';

export class Dropdown extends Component {
  state = {
    expanded: false
  }

  handleExpandClass () {
    return this.state.expanded ? 'expanded' : 'collapsed';
  }

  toggleDropdown () {
    this.setState({expanded: !this.state.expanded});
  }

  render () {
    return (
      <div className='example-container dropdown-wrapper'>
        <div className={`dropdown-parent ${this.handleExpandClass()}`} aria-expanded={ this.state.expanded } onClick={ () => this.toggleDropdown() }>
          <ul className='dropdown-container'>
            <li className='dropdown-item'>Drop Down Item 1</li>
            <li className='dropdown-item'>Drop Down Item 2</li>
            <li className='dropdown-item'>Drop Down Item 3</li>
            <li className='dropdown-item'>Drop Down Item 4</li>
            <li className='dropdown-item'>Drop Down Item 5</li>
          </ul>
          <h4>Dropdown Menu</h4>
          <span className='icon bff-dropdown-carrot' aria-hidden='true'></span>
        </div>
        <div className='html-example'>
          <div><span>{'<'}<span className='el'>div</span><span className='attr'> class</span>=<span className='text'>'dropdown-parent collapsed'</span> <span className='attr'>aria-expanded</span>=<span className='text'>'false'</span>{'>'}</span></div>
            <div className='indent-1'><span>{'<'}<span className='el'>ul</span><span className='attr'> class</span>=<span className='text'>'dropdown-container'</span>{'>'}</span></div>
              <div className='indent-2'><span>{'<'}<span className='el'>li</span><span className='attr'> class</span>=<span className='text'>'dropdown-item'</span>{'>'}Dropdown Item 1{'</'}<span className='el'>li</span>{'>'}</span></div>
              <div className='indent-2'><span>{'<'}<span className='el'>li</span><span className='attr'> class</span>=<span className='text'>'dropdown-item'</span>{'>'}Dropdown Item 2{'</'}<span className='el'>li</span>{'>'}</span></div>
            <div className='indent-1'><span>{'</'}<span className='el'>ul</span>{'>'}</span></div>
            <div className='indent-1'><span>{'<'}<span className='el'>h4</span>{'>'}Dropwdown Menu{'</'}<span className='el'>h4</span>{'>'}</span></div>
          <div><span>{'</'}<span className='el'>div</span>{'>'}</span></div>
        </div>
      </div>
    )
  }

}
